import { type PluginDef, createPlugin } from "@fullcalendar/core"
import { diffDates } from "@fullcalendar/core/internal"
import type { EventDragStartArg } from "@fullcalendar/interaction"

interface StartAlignedEventDrag {
  plugin: PluginDef
  start: (arg: EventDragStartArg) => void
  stop: () => void
}

// TimeGrid drags use the event element's centre as FullCalendar's hit point.
// Its default mutation therefore puts that centre on the target slot, which
// can push the start of a long meeting into the previous day. Rebase the
// mutation on the original event start so the highlighted slot is the start
// shown in the drag preview and eventually delivered to eventDrop.
export const createStartAlignedEventDrag = (): StartAlignedEventDrag => {
  let eventStart: Date | null = null

  return {
    plugin: createPlugin({
      name: "start-aligned-event-drag",
      eventDragMutationMassagers: [
        (mutation, _initialHit, targetHit) => {
          const dateEnv = targetHit.context?.dateEnv

          // DayGrid and the all-day row intentionally keep FullCalendar's
          // date-based behavior. This correction is only for timed slots.
          if (!eventStart || targetHit.dateSpan.allDay || !dateEnv) return

          mutation.datesDelta = diffDates(
            eventStart,
            targetHit.dateSpan.range.start,
            dateEnv
          )
        }
      ]
    }),
    start: ({ event }) => {
      eventStart = event.start
    },
    stop: () => {
      eventStart = null
    }
  }
}
